<template>
    <el-dialog :custom-class="'user-dialog'" :visible="dialogvisible" width="30%"
               @close="$emit('update:dialogvisible', false); visiblePassword=false">
            <component :is="personel"></component>
    </el-dialog>
</template>

<script>
    import yoneticiService from '../WSProvider/YoneticiService'
    import notification from '../notification'

    export default {
        name: 'UserDialog',
        props: ['opsiyon', 'dialogvisible'],
        data() {
            return {
                selection: '',
                personel: this.opsiyon,
            }
        },
    }
</script>
